module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Status fra oprettelsen")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.computedTabs,
      "selected": _vm.selectedTab
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "do-table marg-1-top"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.selectedTab === 'error' ? 'Fejlbeskrivelse' : ''))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.usersFiltered), function(user) {
    return _c('tr', {
      key: user.user_id
    }, [_c('td', [_vm._v(_vm._s(user.user_name))]), _vm._v(" "), _c('td', [(user.result === 'ok') ? _c('span', [_vm._v("✔️")]) : _c('span', {
      staticClass: "italic"
    }, [_vm._v("Ikke oprettet")])]), _vm._v(" "), _c('td', [(user.result === 'error') ? _c('span', {
      staticClass: "do-warning"
    }, [_vm._v("\n              " + _vm._s(_vm.errorDescription(user.error)) + "\n            ")]) : _vm._e()])])
  }), 0)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57e202ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supplements/ShowResponse.vue
// module id = 1656
// module chunks = 1